import axios from "axios";
import { toastr } from "react-redux-toastr";
import { closeModal, openModal } from "./modalAction";

import {
  // FETCH_GGN_PROPCOMS,
  FETCH_GGN_PROPCOM,
  // UPDATE_GGN_PROPCOM,
  SEARCH_GGN_PROPCOMS,
  FETCHING_GGN_PROPCOMS,
  MESSAGE,
} from "./types";

//******************
//search  PropComs SALE

export const searchPropComSales =
  (values, limitCS, offsetCS) => async (dispatch) => {
    try {
      const res = await axios.post("/api/ggn/PropComSaleSearch", {
        values,
        limitCS,
        offsetCS,
      });

      dispatch({ type: SEARCH_GGN_PROPCOMS, payload: res.data });
      dispatch({ type: FETCHING_GGN_PROPCOMS, payload: { fetchingCS: false } });
      dispatch(closeModal());
    } catch (error) {
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again searchMyPropComs"
      );
    }
  };

//search  PropComs RENT

export const searchPropComRents =
  (values, limitCR, offsetCR) => async (dispatch) => {
    try {
      const res = await axios.post("/api/ggn/PropComRentSearch", {
        values,
        limitCR,
        offsetCR,
      });

      dispatch({ type: SEARCH_GGN_PROPCOMS, payload: res.data });
      dispatch({ type: FETCHING_GGN_PROPCOMS, payload: { fetchingCR: false } });
      dispatch(closeModal());
    } catch (error) {
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again searchMyPropComs"
      );
    }
  };

//fetch single PropCom
export const fetchPropCom = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/ggn/PropComDetail/${id}`);

    dispatch({ type: FETCH_GGN_PROPCOM, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

// create PropCom
export const createPropCom = (values, history) => async (dispatch) => {
  try {
    const res = await axios.post("/api/ggn/PropComCreate", {
      values,
    });

    dispatch({ type: MESSAGE, payload: res.data });
    if (values.propertyFor === "SALE") {
      history.push("/ggn/propcom/PropComSaleSearchList");
    } else {
      history.push("/ggn/propcom/PropComRentSearchList");
    }
    dispatch(openModal("MessageModal"));
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
//resetOffset

export const resetOffsetPropComs = () => async (dispatch) => {
  try {
    dispatch({
      type: SEARCH_GGN_PROPCOMS,
      payload: { offsetCS: 0, offsetCR: 0 },
    });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
export const resetPropCom = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GGN_PROPCOM, payload: null });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
